import type React from 'react';

import { useGetStream } from '@vlabs/api/artemy/client';
import { StreamTargetsParameterItem } from '@vlabs/api/artemy/model';
import type { StreamId } from '@vlabs/api/artemy/model';

import { StreamStatusWithActions as StreamStatusWithActionsView } from '../../../shared/ui/stream-statuses';

interface StreamStatusWithActionsProps {
  streamId: StreamId;
}

// Статус потока с кнопками запуска/остановки: самодостаточная сущность —
// сама запрашивает статус (targets=['status']); патч выполняется внутри
// презентационного компонента из shared/ui.
function StreamStatusWithActions({
  streamId,
}: StreamStatusWithActionsProps): React.JSX.Element | null {
  const { data } = useGetStream(streamId, {
    targets: [StreamTargetsParameterItem.status],
  });

  if (data?.status === undefined) return null;

  return (
    <StreamStatusWithActionsView
      status={data.status}
      streamId={streamId}
    />
  );
}

export { StreamStatusWithActions };
